import React from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { usersColumn } from './columns';
import { toast } from 'react-toastify';
import { Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUsersAsync } from './UserStore/userStoreSlice';
// import AddUserForm from './AddUserForm';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';

const User = () => {
  // const [open, setOpen] = React.useState(false);
  const [userName, setUserName] = React.useState('');
  const [page, setPage] = React.useState(1);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const { users, count } = useSelector((state) => {
    const { userReducer } = state;

    return {
      users:
        userReducer.users &&
        userReducer.users.data &&
        userReducer.users.data.users,
      oneuser: userReducer.oneuser,
      count:
        userReducer.users &&
        userReducer.users.data &&
        userReducer.users.data.count,
    };
  });

  React.useEffect(() => {
    // Fetching all users for athenuem
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      dispatch(
        getAllUsersAsync({
          params: {
            name: '',
          },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Users have been fetched.');
        });
    } catch (error) {
      toast.error('Users could not be fetched, please try after some time.');
    }
  };

  const handleSearchUser = () => {
    // API call
    dispatch(
      getAllUsersAsync({
        params: {
          name: userName,
        },
      })
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getAllUsersAsync({
          params: { page: val, limit: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All offers were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  return (
    <Box>
      {/* <Button onClick={handleOpen} variant="contained" color="primary">
        Add User
      </Button> */}

      <Box width={500}>
        <BuzzInput
          size="small"
          placeholder="Search by user name"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          onSubmitEditing={handleSearchUser}
        />
      </Box>

      <Box my={4}>
        <BuzzTable columns={usersColumn} data={users} />
      </Box>
      <Box display="flex" justifyContent="center">
        <BuzzPagination
          onClick={handlePageChange}
          total={count}
          pageNo={page}
          defaultPage={1}
          perPage={10}
        />
      </Box>
      {/* <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <AddUserForm fetchData={fetchData} handleClose={handleClose} />
      </Modal> */}
    </Box>
  );
};

export default User;
